import SliderDisplay from './SliderDisplay';

export default SliderDisplay;
